import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Events } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/events/@eventId/download`,
    params: {} as { eventId: string },
    request: {} as Events.Post.Download,
    response: {} as Events.Post.Response.Download,
    method: HTTP_METHODS.POST,
  },
};

export const id = {};
